import React from 'react';

const Error = ({msg}) => 
{
    return (
        <h1>{msg}</h1>
    )
};

export default Error;